import PropTypes from 'prop-types';
import { useAcceptFirstLoginExperienceMutation } from '../../data/customer';
import { CspConfigurationPropTypes } from '../../propTypes/cspConfigurations';

const useDashboard = ({ featureFlags, setIsWelcomeDashboard, auth0AccessToken, contactId, isSSOAuthentication }) => {
  const [updateFirstLoginExperience] = useAcceptFirstLoginExperienceMutation();
  const handleUpdateFirstLoginExperience = (termsOfUseStatus, takeATourStatus) => {
    const termsOfUseValue = termsOfUseStatus;
    const takeATourValue = takeATourStatus;
    try {
      updateFirstLoginExperience({
        data: { TermsOfUseStatus: termsOfUseValue, TakeATourStatus: takeATourValue },
        auth0Token: auth0AccessToken,
        isFallback: featureFlags?.IsFallbackModeMiddlewareApiEnabled,
        contactId
      }).then((res) => {
        const isWelcomeDashboardState = isSSOAuthentication
          ? res?.data?.TermsOfUseStatus == null && res?.data?.TakeATourStatus == null
          : res?.data?.TakeATourStatus == null;
        setIsWelcomeDashboard(isWelcomeDashboardState);
      });
    } catch (error) {
      throw new Error(error);
    }
  };
  return { handleUpdateFirstLoginExperience };
};

useDashboard.propTypes = {
  featureFlags: CspConfigurationPropTypes,
  setIsWelcomeDashboard: PropTypes.func,
  auth0AccessToken: PropTypes.string,
  contactId: PropTypes.string,
  isSSOAuthentication: PropTypes.bool
};

export default useDashboard;
